(function() {
  // Sicherstellen, dass Klaviyo-Queue existiert
  window._learnq = window._learnq || [];

  // 1) Helper: Event an Klaviyo tracken
  function klTrackAddedToCart(payload) {
    try {
      window._learnq.push(['track', 'Added to Cart', payload]);
    } catch (e) {
      console.warn('[Klaviyo ATC] track error', e);
    }
  }

  // 2) Kontext: Produkt-/Variantendaten aus unserem Liquid-Container lesen
  function getPdpContext(variantId, quantity) {
    var el = document.getElementById('klaviyo-product-json');
    if (!el) return null;

    try {
      var product = JSON.parse(el.getAttribute('data-product'));
      var currency = el.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active);

      var variant = null;
      if (variantId) {
        variant = (product.variants || []).find(function(v) { return String(v.id) === String(variantId); }) || null;
      }

      var name  = product && product.title ? product.title : (document.querySelector('meta[property="og:title"]')?.content || document.title);
      var url   = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
      var image = (product && product.featured_image) ? product.featured_image.src : (document.querySelector('meta[property="og:image"]')?.content || undefined);

      // Shopify-Preise kommen i. d. R. in Cent
      var price     = variant && typeof variant.price === 'number' ? (variant.price / 100) : undefined;
      var compareAt = variant && typeof variant.compare_at_price === 'number' ? (variant.compare_at_price / 100) : undefined;

      return {
        ProductID: product.id,
        VariantID: variant ? variant.id : undefined,
        SKU: variant ? (variant.sku || undefined) : undefined,
        ProductName: name,
        URL: url,
        ImageURL: image,
        Price: price,
        CompareAtPrice: compareAt,
        Quantity: quantity || 1,
        Currency: currency || undefined,
        Brand: product.vendor || undefined,
        Categories: product.tags && product.tags.length ? product.tags : undefined
      };
    } catch (e) {
      console.warn('[Klaviyo ATC] PDP context error', e);
      return null;
    }
  }

  // 3) Klassische Add-to-Cart-Formulare abfangen (/cart/add)
  function onAddToCartSubmit(e) {
    var form = e.target.closest('form');
    if (!form || !/\/cart\/add/.test(form.action)) return;

    var variantId = form.querySelector('input[name="id"]')?.value;
    var quantity  = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);

    var payload = getPdpContext(variantId, quantity) || {
      VariantID: variantId,
      Quantity: quantity,
      ProductName: document.querySelector('meta[property="og:title"]')?.content || document.title,
      URL: document.querySelector('link[rel="canonical"]')?.href || location.href,
      ImageURL: document.querySelector('meta[property="og:image"]')?.content || undefined,
      Price: (function(){ var m = document.querySelector('meta[property="product:price:amount"]'); return m ? parseFloat(m.content) : undefined; })(),
      Currency: (document.querySelector('meta[property="og:price:currency"]')?.content) || (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
    };

    // Nicht blockierend triggern
    setTimeout(function(){ klTrackAddedToCart(payload); }, 0);
  }

  // 4) Alle relevanten ATC-Formulare binden
  function bindForms(scope) {
    (scope || document).querySelectorAll('form[action*="/cart/add"]').forEach(function(f) {
      if (f.__kl_atc_bound) return;
      f.addEventListener('submit', onAddToCartSubmit, { capture: true });
      f.__kl_atc_bound = true;
    });
  }

  // 5) AJAX-/Drawer-ATC über fetch()-Requests abfangen
  (function interceptFetch() {
    if (!window.fetch) return;
    var origFetch = window.fetch;

    window.fetch = function(resource, init) {
      var isAddToCart = false;
      try {
        var url = (typeof resource === 'string') ? resource : (resource && resource.url);
        isAddToCart = url && /\/cart\/add(\.js)?/.test(url);
      } catch(e){}

      if (!isAddToCart) {
        return origFetch.apply(this, arguments);
      }

      var bodyText = '';
      try {
        if (init && init.body && typeof init.body === 'string') bodyText = init.body;
      } catch(e){}

      return origFetch.apply(this, arguments).then(function(resp) {
        try {
          var variantMatch = bodyText.match(/(?:^|&)id=([^&]+)/);
          var qtyMatch     = bodyText.match(/(?:^|&)quantity=([^&]+)/);
          var variantId    = variantMatch ? decodeURIComponent(variantMatch[1]) : undefined;
          var quantity     = qtyMatch ? parseInt(decodeURIComponent(qtyMatch[1]), 10) : 1;

          var payload = getPdpContext(variantId, quantity);
          if (payload) klTrackAddedToCart(payload);
        } catch(e){ console.warn('[Klaviyo ATC] fetch hook error', e); }
        return resp;
      });
    };
  })();

  // 6) Re-bind bei dynamischen Section-Ladevorgängen
  document.addEventListener('DOMContentLoaded', function(){ bindForms(document); });
  document.addEventListener('shopify:section:load', function(e){ bindForms(e.target); });
  document.addEventListener('page:load', function(){ bindForms(document); });

})();
